import { render, staticRenderFns } from "./DocMasterUpload.vue?vue&type=template&id=53c88c4c&scoped=true&"
import script from "./DocMasterUpload.vue?vue&type=script&setup=true&lang=js&"
export * from "./DocMasterUpload.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DocMasterUpload.vue?vue&type=style&index=0&id=53c88c4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c88c4c",
  null
  
)

export default component.exports